import clsx from "clsx";
import type { ReactNode } from "react";

/** 各 section の見出し帯。 Title (Headline2 / responsive) + 右寄せ actions slot。 */
type DxSectionHeaderProps = {
  title: ReactNode;
  actions?: ReactNode;
  as?: "h1" | "h2" | "h3";
  className?: string;
  /** 見出しの文字スタイル上書き (既定: Headline2 responsive)。 */
  titleClassName?: string;
};

export function DxSectionHeader({
  title,
  actions,
  as = "h2",
  className,
  titleClassName = "dx-headline-2-mobile xs:dx-headline-2-desktop",
}: DxSectionHeaderProps) {
  const Heading = as;
  return (
    <header
      className={clsx(
        "flex items-center justify-between gap-[8px] py-[8px] pr-[8px] pl-[16px]",
        className,
      )}
    >
      <Heading
        className={clsx(
          titleClassName,
          "text-dx-text-default min-w-0 flex-1 pt-[10px] pb-[6px]",
        )}
      >
        {title}
      </Heading>
      {actions !== undefined && (
        <div className="flex flex-none items-center">{actions}</div>
      )}
    </header>
  );
}
